import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

export const PAGE_HEADER = ({ darkMode }) => cxs({
  background: darkMode ? COLOURS.grey.codGrey : COLOURS.mono.white,
  color: darkMode ? COLOURS.mono.white : COLOURS.mono.black,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '40px',
  height: '100px',

  ' > *': {
    ':first-child': {
      flex: 1
    }
  }
});

export const ACTION_CONTENT = cxs({
  display: 'flex',
  alignItems: 'center'
});

export const ACTION_BTN_MOBILE = cxs({
  width: '50px'
});